import JugglingBig from "./JugglingBig"

export default function JugglingScreen() {
  return (
    <div className="pointer-events-none fixed inset-0 z-50 flex items-center justify-center">
      <div className="-translate-y-[11.8vh]">
        <JugglingBig />
      </div>
    </div>
  )
}
